import React from 'react'
import SyncButton from '../../../ui/sync-button'

const GovRegistrationSyncButton = ({ id, onComplete, ccms_registrations = [] }) =>
  ccms_registrations.length > 0 ? (
    <SyncButton
      compact
      right
      key={`govRegSyncButton-${id}`}
      steps={stepsForRegistrations(ccms_registrations)}
      onComplete={onComplete}
    />
  ) : null

const stepsForRegistrations = (registrations = []) =>
  registrations.map(registration => ({
    syncPath: `/api/gov-registrations/${registration.gov_id}/sync`,
    text: `Updating details for ${registration.name}`,
  }))

export default GovRegistrationSyncButton



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccms-registrations/sync-button.jsx